module.exports = __webpack_public_path__ + "img/ygjc002.bbfc3b76.jpg";